import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 2.5, orderValue: 'clientName' },
  { title: 'Requerido', flex: 2.5, orderValue: 'requiredMarginValue' },
  { title: 'Em Garantia', flex: 2.5, orderValue: 'totalGuaranteeValue' },
  { title: 'Saldo', flex: 2, orderValue: 'marginBalanceValue' },
];
